import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { debounceTime, fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[appDynamicHeight]'
})
export class DynamicHeight {

  @Input() offset = 130;       // default offset
  @Input() minHeight = 300;    // default minimum height

  private resizeSubscription!: Subscription;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.setHeight();
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(150))
      .subscribe(() => this.setHeight());
  }

  private setHeight() {
    const newHeight = Math.max(window.innerHeight - this.offset, this.minHeight);
    this.renderer.setStyle(this.el.nativeElement, 'height', `${newHeight}px`);
  }

  ngOnDestroy() {
    this.resizeSubscription?.unsubscribe();
  }
}
